import { render, staticRenderFns } from "./EventsPast.vue?vue&type=template&id=0e016caa&"
import script from "./EventsPast.vue?vue&type=script&lang=js&"
export * from "./EventsPast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports